import React from "react";
import { Phone, Calendar, CheckCircle2, Mail, ShieldCheck, Clock, Wrench, DollarSign } from "lucide-react";

const badges = [
  { icon: Wrench, label: "Mobile Service" },
  { icon: ShieldCheck, label: "Professional Equipment" },
  { icon: Clock, label: "Fast Response" },
  { icon: DollarSign, label: "Honest Pricing" },
];

export const Hero = () => {
  return (
    <section id="home" className="relative bg-brand-surface overflow-hidden">
      <div className="container-mv pt-14 pb-20 md:pt-20 md:pb-28 grid lg:grid-cols-12 gap-12 items-center">
        {/* Left */}
        <div className="lg:col-span-6 animate-fade-up">
          <div className="inline-flex items-center gap-2 rounded-full bg-white border border-neutral-200 px-3 py-1 text-xs font-semibold tracking-wide text-neutral-700 shadow-sm">
            <span className="w-1.5 h-1.5 rounded-full bg-brand-red" />
            SERVING CALGARY &amp; AREA
          </div>

          <h1 className="mt-6 font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-brand-black">
            Mobile Tire Service <br />
            That <span className="text-brand-red">Comes To You.</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-neutral-600 leading-relaxed max-w-xl">
            Skip the tire shop. Whether you're at home, at work, or stranded with a flat, Mavtech Mobile Tires delivers fast, professional tire service throughout Calgary and surrounding areas.
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="tel:4034043515"
              data-testid="hero-call-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-black text-white px-7 py-3.5 text-sm font-semibold hover:bg-neutral-800 active:scale-95 transition-all"
            >
              <Phone className="w-4 h-4" /> Call Now · 403-404-3515
            </a>
            <a
              href="#contact"
              data-testid="hero-book-btn"
              className="inline-flex items-center justify-center gap-2 rounded-full bg-brand-red text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#CC0000] active:scale-95 transition-all shadow-md shadow-red-200"
            >
              <Calendar className="w-4 h-4" /> Book Online
            </a>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-neutral-700">
            <a href="tel:4034043515" className="inline-flex items-center gap-2 hover:text-brand-red">
              <Phone className="w-4 h-4 text-brand-red" /> 403-404-3515
            </a>
            <a href="mailto:mavtechtires@hotmail.com" className="inline-flex items-center gap-2 hover:text-brand-red">
              <Mail className="w-4 h-4 text-brand-red" /> mavtechtires@hotmail.com
            </a>
          </div>

          {/* Trust badges */}
          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-3">
            {badges.map(({ icon: Icon, label }) => (
              <div key={label} className="flex items-center gap-2 rounded-xl bg-white border border-neutral-200 px-3 py-2.5 shadow-sm">
                <CheckCircle2 className="w-4 h-4 text-brand-red shrink-0" />
                <span className="text-xs font-semibold text-neutral-800">{label}</span>
                <Icon className="w-4 h-4 text-neutral-300 ml-auto hidden sm:block" />
              </div>
            ))}
          </div>
        </div>

        {/* Right image */}
        <div className="lg:col-span-6 animate-fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative rounded-2xl overflow-hidden shadow-premium-hover border border-neutral-200">
            <img
              src="https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85"
              alt="Mavtech mobile tire technician servicing a vehicle"
              className="w-full h-[420px] md:h-[560px] object-cover"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            <div className="absolute left-6 bottom-6 right-6 flex items-end justify-between">
              <div>
                <div className="text-white/80 text-xs uppercase tracking-widest">On-site service</div>
                <div className="text-white font-display font-bold text-2xl">Calgary &amp; Area</div>
              </div>
              <div className="hidden sm:flex flex-col items-end">
                <div className="text-white/80 text-xs">Avg. response</div>
                <div className="text-white font-bold text-xl">Same day</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
